import { styled as a, Typography as f } from "@mui/material";
import h from "../../../hooks/generic/useCSR.js";
import C from "../../../../ui-lib/components/ApeironTooltip.js";
import * as T from "ramda";
import * as x from "ramda-adjunct";
import { useMemo as c, Children as s, isValidElement as y, useId as R, cloneElement as g } from "react";
import { jsx as l, jsxs as j, Fragment as A } from "react/jsx-runtime";
const b = a(f)`
  font-size: 14px;
  font-weight: 300;
  margin: 6px;
`, E = (o) => {
  const {
    children: t,
    disabled: d = !1,
    reason: m = ""
  } = o, r = c(() => {
    if (t) {
      const i = s.map(t, (e) => {
        if (y(e))
          return e;
      });
      return (i == null ? void 0 : i[0]) || null;
    }
    return null;
  }, [t]), p = d && x.isNotEmpty(m), n = R(), u = c(() => {
    if (r) {
      const i = g(r, {
        "data-tooltip-id": n
      });
      return s.count(t) > 1 ? T.update(0, i, s.toArray(t)) : i;
    }
    return t;
  }, [t, r, n]);
  return /* @__PURE__ */ j(A, {
    children: [u, p && /* @__PURE__ */ l(C, {
      id: n,
      children: /* @__PURE__ */ l(b, {
        children: m
      })
    })]
  });
}, B = (o) => {
  const {
    children: t
  } = o;
  return h() ? /* @__PURE__ */ l(E, {
    ...o
  }) : t;
};
export {
  B as default
};
//# sourceMappingURL=ApeironButtonDisableTip.js.map
